export default __webpack_public_path__ + "static/media/sandal11.5f2388e0.jpeg";